module.exports = __webpack_public_path__ + "static/media/display-2@768.5fc88403.png";